/*
 *
 *  Vue Main Entry & Config
 */

// import main deps
import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store/s.index'

// methods
import { addBodyClasses, removeBodyClasses } from '@/methods/m.general'

// plugins
import vuetify from '@/plugins/vuetify/vuetify.config'
import VueLazyload from 'vue-lazyload'
import aos, { aosOptions } from '@/plugins/aos'
import '@/plugins/vuemeta/vuemeta.config'
import '@/plugins/vee-validate/vee-validate.config'
import '@/plugins/anime'

// filters
import '@/methods/filters'

// analytics
import '@/plugins/vue-analytics'

// import mixins
import mxGlobalVars from '@/mixins/mx.global.vars'
import mxGlobalMethods from '@/mixins/mx.global.methods'
import mxMobileDetect from '@/mixins/mx.mobile.detect'

// use mixins
Vue.mixin(mxGlobalVars)
Vue.mixin(mxGlobalMethods)
Vue.mixin(mxMobileDetect)

// use plugins
Vue.use(VueLazyload)

// production tip
Vue.config.productionTip = false

// set instance
const instance = {
  router,
  store,
  vuetify,
  render: h => h(App),
  mounted: () => document.dispatchEvent(new Event('x-app-rendered')),
  created() {
    aos.init(aosOptions)
  }
}

/**
 * Init App
 */
initApp()

/**
 * Handle Init App
 */
async function initApp() {
  // add body loading
  addBodyClasses(['app--loading'])
  // check webp support
  await store.dispatch('checkWebpSupport')
  // set delay
  setTimeout(() => {
    // add body loading finished
    addBodyClasses(['app--loading-finished'])
    /**
     * Create Vue Instance
     */
    new Vue(instance).$mount('#app')
    // set delay
    setTimeout(() => {
      // add body ready
      addBodyClasses(['app--ready'])
      // remove unwanted classes
      removeBodyClasses(['app--loading', 'app--loading-finished'])
    }, 200)
  }, 200)
}

// developed by ekleel console message
if (process.env.NODE_ENV === 'production') {
  console.log(
    '%cThis app is developed by ekleel.net. Be a part of our Team!',
    'color: #4095f3;text-shadow: 1px 1px 12px #0d2e52;'
  )
}
